(function () {
    'use strict';
  
    var root = document.getElementById('reorder-room');
    if (!root) return;
  
    var SHADES = [['Sienna Brown', '#8a5a3c'], ['Cashmere Beige', '#e6c9a8']];
  
    var D = { bras: 1, braItems: [{ style: '', color: '' }], forms: 1, formShade: '', spare: null, spareShade: '', candle: '', pay: null };
    var SHOP = root.dataset.shop || 'https://myya.com';
    var ORDER_ENDPOINT = root.dataset.orderEndpoint || '';
    var FORM_HANDLE = { 'Sienna Brown': 'breast-form-in-sienna', 'Cashmere Beige': 'breast-form-in-cashmere' };
    var CANDLE_HANDLE = {
      'Sheer Delight': 'myya-sheer-delight-signature-candle',
      'Midnight Show': 'myya-midnight-show-signature-candle',
      'Sweet Dream': 'myya-sweet-dream-signature-candle'
    };
    var CDN = 'https://cdn.shopify.com/s/files/1/0578/8074/0047/files/';
    var HEX = { 'Luna Black': '#1c1c1c', 'Honey Beige': '#d8b487', 'Amethyst Purple': '#7c5a8f' };
    var BRA = {
      Josie: { sub: 'soft lace trim, wire-free', colors: {
        'Amethyst Purple': { img: CDN + 'MYYA-TL-210539_front_b1f732f6-6937-4d77-9771-0960f97d20bb.jpg?v=1714419852', handle: 'the-josie-bra-amethyst' },
        'Honey Beige': { img: CDN + 'MYYA-TL-210270_front.jpg?v=1714419788', handle: 'the-josie-bra-honey' },
        'Luna Black': { img: CDN + '6A6511B6-50EB-4E8F-9EC0-297F4DA54E08.png?v=1775512218', handle: 'the-josie-bra-luna-black' }
      }},
      Marie: { sub: 'cotton, everyday', colors: {
        'Honey Beige': { img: CDN + '0E1A59EE-834D-4460-810A-4C35380E9FA1.png?v=1775512216', handle: 'the-marie-bra-honey' },
        'Luna Black': { img: CDN + 'MYYA-MAR-CPL001.jpg?v=1775512217', handle: 'the-marie-bra-luna-black' }
      }},
      Vivian: { sub: 'front closure', colors: {
        'Luna Black': { img: CDN + 'MYYA-VIV-FC001.jpg?v=1775512216', handle: 'the-vivian-bra-luna-black' },
        'Honey Beige': { img: CDN + 'MYYA-VIV-FC299_front.jpg?v=1714419587', handle: 'the-vivian-bra-honey' }
      }},
      Mae: { sub: 'moulded cup, full coverage', colors: {
        'Honey Beige': { img: CDN + 'MYYA-TL-SS4013270.jpg?v=1775512212', handle: 'mae-bra' }
      }},
      Ruth: { sub: 'underwire, pocketed', colors: {
        'Luna Black': { img: CDN + 'MYYA-TL-B4009001.jpg?v=1775512212', handle: 'ruth-bra' }
      }}
    };
    var STYLE_ORDER = ['Josie', 'Marie', 'Vivian', 'Mae', 'Ruth'];
  
    var steps = [
      { id: 'welcome', render: function () {
        return '<div class="rr-kick">The Reorder Room</div>' +
          '<h1>Welcome back. Let\'s make this easy.</h1>' +
          '<p class="rr-sub">If your size hasn\'t changed, you don\'t need another fitting. Pick what you love, and we handle the rest — including your insurance.</p>' +
          '<div class="rr-assure">' +
            '<div><span class="rr-tick">✓</span> No appointment</div>' +
            '<div><span class="rr-tick">✓</span> We bill your insurance</div>' +
            '<div><span class="rr-tick">✓</span> Ships to your door</div>' +
          '</div>' +
          '<div class="rr-nav"><button type="button" class="rr-btn rr-btn--go" data-action="next">Begin</button>' +
          '<span class="rr-enter">press <b>Enter ↵</b></span></div>';
      }},
  
      { id: 'name', valid: function () { return val('rr-fn') && val('rr-ln'); }, render: function () {
        return '<div class="rr-kick">A little about you</div>' +
          '<h2>First, your name.</h2>' +
          '<div class="rr-fields"><div class="rr-row2">' +
            '<div class="rr-fld"><label>First name</label><input id="rr-fn" value="' + esc(D.fn || '') + '" placeholder="Jane" data-sync></div>' +
            '<div class="rr-fld"><label>Last name</label><input id="rr-ln" value="' + esc(D.ln || '') + '" placeholder="Smith" data-sync></div>' +
          '</div></div>' + nav();
      }},
  
      { id: 'contact', valid: function () { return /@/.test(val('rr-em')); }, render: function () {
        return '<h2>Where can we reach you?</h2>' +
          '<p class="rr-sub">So we can confirm your order and any coverage details.</p>' +
          '<div class="rr-fields">' +
            '<div class="rr-fld"><label>Email</label><input id="rr-em" value="' + esc(D.em || '') + '" placeholder="name@email.com" data-sync></div>' +
            '<div class="rr-fld"><label>Mobile phone</label><input id="rr-ph" value="' + esc(D.ph || '') + '" placeholder="(301) 555-0100" data-sync></div>' +
          '</div>' + nav();
      }},
  
      { id: 'insChanged', valid: function () { return D.insChanged != null; }, render: function () {
        return '<div class="rr-kick">Insurance</div>' +
          '<h2>Has your insurance changed since your last visit?</h2>' +
          pick('insChanged', [['no', 'No, same plan'], ['yes', 'Yes, it changed']]) + nav();
      }},
  
      { id: 'insDetails', show: function () { return D.insChanged === 'yes'; }, valid: function () { return val('rr-carrier'); }, render: function () {
        return '<h2>Tell us about your new plan.</h2>' +
          '<p class="rr-sub">Our billing team will verify everything before anything ships.</p>' +
          '<div class="rr-fields">' +
            '<div class="rr-fld"><label>Insurance carrier</label><input id="rr-carrier" value="' + esc(D.carrier || '') + '" placeholder="CareFirst BlueCross" data-sync></div>' +
            '<div class="rr-row2">' +
              '<div class="rr-fld"><label>Member ID</label><input id="rr-member" value="' + esc(D.member || '') + '" data-sync></div>' +
              '<div class="rr-fld"><label>Group number</label><input id="rr-grp" value="' + esc(D.grp || '') + '" data-sync></div>' +
            '</div>' +
          '</div>' + nav();
      }},
  
      { id: 'refit', valid: function () { return D.refit != null; }, render: function () {
        return '<div class="rr-kick">Your fit</div>' +
          '<h2>Would you like a refit, or reorder what worked?</h2>' +
          '<p class="rr-sub">Most women reorder. If your body\'s changed, we\'ll fit you from home.</p>' +
          pick('refit', [['reorder', 'Reorder my usual', 'Same sizes and styles as last time'], ['refit', 'I\'d like a refit first', 'A quick visit with a certified fitter']]) + nav();
      }},
  
      { id: 'bras', valid: function () { return true; }, render: function () {
        return '<div class="rr-kick">Your bras</div>' +
          '<h2>How many bras this time?</h2>' +
          '<p class="rr-sub">Your plan covers up to 3 each quarter. Mix any styles and colors you like.</p>' +
          pick('bras', [['0', 'None right now'], ['1', '1'], ['2', '2'], ['3', '3']]) + nav();
      }},
  
      { id: 'braBuild', show: function () { return D.bras > 0; }, valid: function () { return brasValid(); }, render: function () {
        initBras();
        return '<div class="rr-kick">Your bras</div>' +
          '<h2>Build your ' + (D.bras === 1 ? 'bra' : D.bras + ' bras') + '.</h2>' +
          '<p class="rr-sub">Each one can be a different style and color. Pick what you love.</p>' +
          '<div class="rr-builder">' + D.braItems.map(function (it, k) { return braSlot(it, k); }).join('') + '</div>' + nav();
      }},
  
      { id: 'forms', valid: function () { return true; }, render: function () {
        return '<div class="rr-kick">Your breast form</div>' +
          '<h2>Need a new breast form?</h2>' +
          '<p class="rr-sub">Insurance covers one every two years. If it\'s been that long, it\'s yours.</p>' +
          pick('forms', [['0', 'Not this time'], ['1', 'Yes, one'], ['2', 'Two']]) + nav();
      }},
  
      { id: 'formShade', show: function () { return D.forms > 0; }, valid: function () { return D.formShade; }, render: function () {
        return '<h2>Which shade matches you?</h2>' +
          '<div class="rr-swatch" style="margin-top:26px">' +
            SHADES.map(function (c) {
              return '<button type="button" class="rr-sw ' + (D.formShade === c[0] ? 'rr-sel' : '') + '" data-set="formShade" data-value="' + esc(c[0]) + '">' +
                '<span class="rr-chip" style="background:' + c[1] + '"></span>' + esc(c[0]) + '</button>';
            }).join('') +
          '</div>' + nav();
      }},
  
      { id: 'spare', show: function () { return D.forms > 0; }, valid: function () { return D.spare != null; }, render: function () {
        if (D.formShade) D.spareShade = D.formShade;
        return '<div class="rr-kick">One more thing</div>' +
          '<h2>Keep a backup?</h2>' +
          '<p class="rr-sub">Insurance covers one form every two years — a second is never covered, so it\'s yours at our cash price. The women who keep one never go back to just the one.</p>' +
          '<div class="rr-opts">' +
            '<button type="button" class="rr-opt ' + (D.spare === 0 ? 'rr-sel' : '') + '" data-set="spare" data-value="0"><span class="rr-dot"></span><span><b>No, just the one</b></span></button>' +
            '<button type="button" class="rr-opt ' + (D.spare === 1 ? 'rr-sel' : '') + '" data-set="spare" data-value="1"><span class="rr-dot"></span><span><b>Yes, add a backup — $179</b><small>One for wash day, one for travel, one just in case. Same ' + esc(D.formShade || 'shade') + ' as yours. $250 off · FSA/HSA welcome · paid today</small></span></button>' +
          '</div>' + nav();
      }},
  
      { id: 'notes', valid: function () { return true; }, render: function () {
        return '<h2>Anything you\'d like your fitter to know?</h2>' +
          '<p class="rr-sub">Optional — a change, a preference, a question. We read every one.</p>' +
          '<div class="rr-fields"><div class="rr-fld"><textarea id="rr-notes" rows="3" placeholder="Optional" data-sync>' + esc(D.notes || '') + '</textarea></div></div>' + nav();
      }},
  
      { id: 'candle', valid: function () { return true; }, render: function () {
        return '<div class="rr-kick">A small thank-you</div>' +
          '<h2>Pick a candle, on us.</h2>' +
          '<p class="rr-sub">Our gift while supplies last — added free to your order.</p>' +
          pick('candle', [['Sheer Delight', 'Sheer Delight', 'Recovery candle'], ['Midnight Show', 'Midnight Show', 'Luxury scented'], ['Sweet Dream', 'Sweet Dream', 'Signature'], ['none', 'No candle, thanks']]) + nav();
      }},
  
      { id: 'review', valid: function () { return true; }, render: function () {
        return '<div class="rr-kick">Almost done</div>' +
          '<h2>Here\'s your order.</h2>' +
          '<div class="rr-rev" id="rr-rev-box"></div>' +
          '<div class="rr-assure"><div><span class="rr-tick">✓</span> Everything below can go through insurance — or you can pay yourself</div></div>' + nav('Looks right →');
      }},
  
      { id: 'pay', valid: function () { return D.pay != null; }, render: function () {
        return '<div class="rr-kick">How you\'d like to pay</div>' +
          '<h2>Two ways from here.</h2>' +
          '<p class="rr-sub">If your deductible is met, insurance is usually your best deal. If it isn\'t — or you\'d rather not wait on a claim — paying yourself is faster and often cheaper.</p>' +
          '<div class="rr-opts">' +
            '<button type="button" class="rr-opt ' + (D.pay === 'ins' ? 'rr-sel' : '') + '" data-set="pay" data-value="ins"><span class="rr-dot"></span><span><b>Bill my insurance</b><small>We verify your benefits and submit the claim. No cost to you if you\'re covered.</small></span></button>' +
            '<button type="button" class="rr-opt ' + (D.pay === 'cash' ? 'rr-sel' : '') + '" data-set="pay" data-value="cash"><span class="rr-dot"></span><span><b>Pay myself now &amp; check out</b><small>Skip the claim. Save with code CASHPAY at checkout — FSA/HSA cards welcome.</small></span></button>' +
          '</div>' + nav();
      }},
  
      { id: 'sign', show: function () { return D.pay === 'ins'; }, valid: function () { return val('rr-sig'); }, render: function () {
        return '<h2>One signature and you\'re done.</h2>' +
          '<p class="rr-sub">This authorizes Myya to process your refill through your insurance, per benefit guidelines. Any patient responsibility is confirmed before shipping.</p>' +
          '<div class="rr-fields rr-sig"><div class="rr-fld"><label>Type your full name to sign</label><input id="rr-sig" value="' + esc(D.sig || '') + '" placeholder="Jane Smith" data-sync></div></div>' + nav('Submit my order');
      }},
  
      { id: 'done', render: function () {
        var spareBlock = (D.pay === 'ins' && D.spare > 0)
          ? '<div class="rr-spare-box">' +
              '<p style="font-size:16px;margin-bottom:4px">One last step for your <b>spare form</b>.</p>' +
              '<p class="rr-sub" style="font-size:15px;margin:0 auto 16px">The spare isn\'t covered by insurance, so it\'s paid separately — $179 with FSA/HSA welcome.</p>' +
              '<button type="button" class="rr-btn rr-btn--go" data-action="checkout">Pay for my spare — $179</button>' +
            '</div>'
          : '';
        return '<div class="rr-done">' +
          '<div class="rr-ring">✓</div>' +
          '<h1>That\'s it, ' + esc(D.fn || 'friend') + '.</h1>' +
          '<p class="rr-sub" style="margin:0 auto">Your order is in. Our team will verify your benefits and reach out if we need anything — otherwise it\'s on its way.</p>' +
          spareBlock +
        '</div>';
      }}
    ];
  
    var i = 0;
    var order = [];
    var FIELD_MAP = {
      'rr-fn': 'fn', 'rr-ln': 'ln', 'rr-em': 'em', 'rr-ph': 'ph',
      'rr-carrier': 'carrier', 'rr-member': 'member', 'rr-grp': 'grp',
      'rr-notes': 'notes', 'rr-sig': 'sig'
    };
  
    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  
    function styleThumb(st) {
      var c = BRA[st].colors;
      return c[Object.keys(c)[0]].img;
    }
  
    function initBras() {
      var n = D.bras;
      var a = D.braItems || [];
      while (a.length < n) a.push({ style: '', color: '' });
      a.length = n;
      D.braItems = a;
    }
  
    function setBraStyle(k, st) {
      var it = D.braItems[k];
      it.style = st;
      if (!BRA[st].colors[it.color]) it.color = '';
      save();
      paint();
    }
  
    function setBraColor(k, c) {
      D.braItems[k].color = c;
      save();
      paint();
    }
  
    function brasValid() {
      return (D.braItems || []).every(function (b) { return b.style && b.color; });
    }
  
    function shopBase() {
      var base = (SHOP || 'https://myya.com').replace(/\/$/, '');
      return base.indexOf('http') === 0 ? base : 'https://myya.com';
    }
  
    function getLineItems(includeSpare) {
      var items = [];
      (D.braItems || []).forEach(function (b) {
        if (b.style && b.color && BRA[b.style] && BRA[b.style].colors[b.color]) {
          items.push({
            handle: BRA[b.style].colors[b.color].handle,
            qty: 1,
            title: BRA[b.style].colors[b.color].title || ('The ' + b.style + ' Bra · ' + b.color)
          });
        }
      });
      for (var f = 0; f < (D.forms || 0); f++) {
        if (D.formShade && FORM_HANDLE[D.formShade]) {
          items.push({
            handle: FORM_HANDLE[D.formShade],
            qty: 1,
            title: 'Myya Breast Form in ' + D.formShade
          });
        }
      }
      if (D.candle && D.candle !== 'none' && CANDLE_HANDLE[D.candle]) {
        items.push({
          handle: CANDLE_HANDLE[D.candle],
          qty: 1,
          title: D.candle + ' Candle'
        });
      }
      if (includeSpare && D.spare > 0 && D.spareShade && FORM_HANDLE[D.spareShade]) {
        items.push({
          handle: FORM_HANDLE[D.spareShade],
          qty: 1,
          title: 'Spare Breast Form in ' + D.spareShade + ' (cash)'
        });
      }
      return items;
    }
  
    function fetchProduct(handle) {
      return fetch(shopBase() + '/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
  
    function firstAvailableVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var i, v;
      for (i = 0; i < product.variants.length; i++) {
        v = product.variants[i];
        if (v.available) return v;
      }
      return product.variants[0];
    }
  
    function resolveLineItems(includeSpare) {
      var items = getLineItems(includeSpare);
      if (!items.length) return Promise.resolve([]);
      return Promise.all(items.map(function (it) {
        return fetchProduct(it.handle).then(function (product) {
          var variant = firstAvailableVariant(product);
          if (!variant) return null;
          return {
            variant_id: variant.id,
            quantity: it.qty,
            title: product ? product.title : it.title,
            handle: it.handle,
            price: variant.price || ''
          };
        });
      })).then(function (resolved) {
        return resolved.filter(Boolean);
      });
    }
  
    function submitOrder(resolved, includeSpare) {
      if (!ORDER_ENDPOINT || !resolved.length) return;
      var bras = (D.braItems || []).filter(function (b) { return b.style && b.color; })
        .map(function (b) { return b.style + '|' + b.color; }).join(';;');
      var variantIds = resolved.map(function (r) {
        return r.variant_id + ':' + r.quantity + ':' + (r.price || '');
      }).join(',');
      var prices = resolved.map(function (r) { return r.price || ''; }).join(',');
      var lineItems = JSON.stringify(resolved.map(function (r) {
        return {
          variant_id: r.variant_id,
          quantity: r.quantity,
          title: r.title,
          handle: r.handle,
          price: r.price || ''
        };
      }));
      var p = new URLSearchParams({
        firstName: D.fn || '', lastName: D.ln || '', email: D.em || '', phone: D.ph || '',
        insuranceChanged: D.insChanged === 'yes' ? 'yes' : 'no', carrier: D.carrier || '',
        memberId: D.member || '', groupNumber: D.grp || '',
        refit: D.refit === 'refit' ? 'yes' : 'no',
        candle: (D.candle && D.candle !== 'none') ? D.candle : '', notes: D.notes || '',
        bras: bras, formsCount: String(D.forms || 0),
        formShade: D.forms > 0 ? (D.formShade || '') : '',
        signature: D.sig || '', spare: String(D.spare || 0),
        payMethod: D.pay || 'ins', variantIds: variantIds, prices: prices, lineItems: lineItems
      });
      try { fetch(ORDER_ENDPOINT, { method: 'POST', body: p, keepalive: true }).catch(function () {}); } catch (e) {}
    }
  
    function redirectToCart(resolved) {
      if (!resolved.length) {
        window.location.href = SHOP + '/collections/all';
        return;
      }
      var cart = resolved.map(function (r) { return r.variant_id + ':' + r.quantity; }).join(',');
      try { localStorage.removeItem('myya_reorder'); } catch (e) {}
      window.location.href = SHOP + '/discount/CASHPAY?redirect=' + encodeURIComponent('/cart/' + cart);
    }
  
    function finishOrder(resolved, includeSpare) {
      submitOrder(resolved, includeSpare);
      try { localStorage.removeItem('myya_reorder'); } catch (e) {}
    }
  
    function build() {
      order = steps.filter(function (s) { return !s.show || s.show(); });
    }
  
    function cur() {
      return order[i];
    }
  
    function val(id) {
      var e = root.querySelector('#' + id);
      return e ? e.value.trim() : '';
    }
  
    function setV(k, v) {
      D[k] = (k === 'bras' || k === 'forms' || k === 'spare') ? parseInt(v, 10) : v;
      save();
      paint();
    }
  
    function chk() {
      syncInputs();
      var s = cur();
      var b = root.querySelector('#rr-go-btn');
      if (b && s.valid) b.disabled = !s.valid();
    }
  
    function syncInputs() {
      Object.keys(FIELD_MAP).forEach(function (id) {
        var e = root.querySelector('#' + id);
        if (e) D[FIELD_MAP[id]] = e.value;
      });
    }
  
    function braSlot(it, k) {
      var styles = STYLE_ORDER.map(function (st) {
        return '<button type="button" class="rr-stthumb ' + (it.style === st ? 'rr-sel' : '') + '" data-bra-style="' + k + '" data-style="' + esc(st) + '">' +
          '<img src="' + styleThumb(st) + '" alt="' + esc(st) + '" loading="lazy">' +
          '<span>' + esc(st) + '</span></button>';
      }).join('');
  
      var colors = '<p class="rr-pickhint">Choose a style, then a color</p>';
      if (it.style) {
        var cs = BRA[it.style].colors;
        colors = '<div class="rr-colrow">' + Object.keys(cs).map(function (c) {
          return '<button type="button" class="rr-colsw ' + (it.color === c ? 'rr-sel' : '') + '" data-bra-color="' + k + '" data-color="' + esc(c) + '" title="' + esc(c) + '">' +
            '<span class="rr-chip" style="background:' + HEX[c] + '"></span>' + esc(c.split(' ')[0]) + '</button>';
        }).join('') + '</div>';
      }
  
      var chosen = (it.style && it.color) ? BRA[it.style].colors[it.color].img : null;
      return '<div class="rr-slot">' +
        '<div class="rr-slot-body">' +
          '<div class="rr-slot-head"><span>Bra ' + (k + 1) + '</span>' + (it.style ? '<em>' + esc(it.style) + ' · ' + esc(BRA[it.style].sub) + '</em>' : '') + '</div>' +
          '<div class="rr-strow">' + styles + '</div>' +
          colors +
        '</div>' +
        '<div class="rr-slot-img">' + (chosen ? '<img src="' + chosen + '" alt="">' : '<div class="rr-ph"><i>?</i></div>') + '</div>' +
      '</div>';
    }
  
    function pick(key, opts) {
      return '<div class="rr-opts">' + opts.map(function (o) {
        var sel = String(D[key]) === o[0] ? 'rr-sel' : '';
        return '<button type="button" class="rr-opt ' + sel + '" data-set="' + esc(key) + '" data-value="' + esc(o[0]) + '">' +
          '<span class="rr-dot"></span><span><b>' + esc(o[1]) + '</b>' + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</span></button>';
      }).join('') + '</div>';
    }
  
    function nav(label) {
      return '<div class="rr-nav">' +
        (i > 0 ? '<button type="button" class="rr-btn rr-btn--back" data-action="prev">← Back</button>' : '') +
        '<button type="button" class="rr-btn rr-btn--go" id="rr-go-btn" data-action="next">' + esc(label || 'Continue') + '</button>' +
        '<span class="rr-enter">press <b>Enter ↵</b></span></div>';
    }
  
    function paint() {
      build();
      if (i >= order.length) i = order.length - 1;
      var s = cur();
      root.querySelector('#rr-panel').innerHTML = '<div class="rr-screen rr-on">' + s.render() + '</div>';
      root.querySelector('#rr-bar').style.width = (i / (order.length - 1) * 100) + '%';
      if (s.id === 'review') renderReview();
      var b = root.querySelector('#rr-go-btn');
      if (b && s.valid) b.disabled = !s.valid();
      var first = root.querySelector('#rr-panel input');
      if (first) setTimeout(function () { first.focus(); }, 120);
    }
  
    function renderReview() {
      var L = [];
      L.push(['Name', (D.fn || '') + ' ' + (D.ln || ''), 'name']);
      L.push(['Insurance', D.insChanged === 'yes' ? (D.carrier || 'Updated') : 'Same as on file', 'insChanged']);
      if (D.bras > 0) (D.braItems || []).forEach(function (b, n) { L.push(['Bra ' + (n + 1), b.style + ' · ' + b.color, 'bras']); });
      if (D.forms > 0) L.push(['Breast form (' + D.forms + ')', D.formShade, 'forms']);
      if (D.spare > 0) L.push(['Spare form — $179 · cash', D.spareShade, 'spare']);
      if (D.candle && D.candle !== 'none') L.push(['Free candle', D.candle, 'candle']);
      if (D.refit === 'refit') L.push(['Fit', 'Refit requested', 'refit']);
      root.querySelector('#rr-rev-box').innerHTML = L.map(function (r) {
        return '<div class="rr-rev-row"><span>' + esc(r[0]) + '</span><b>' + esc(r[1] || '—') + ' <a data-jump="' + esc(r[2]) + '">edit</a></b></div>';
      }).join('');
    }
  
    function jumpTo(id) {
      build();
      var idx = order.findIndex(function (s) { return s.id === id; });
      if (idx >= 0) { i = idx; paint(); }
    }
  
    function next() {
      syncInputs();
      var s = cur();
      if (s.valid && !s.valid()) return;
      save();
      flashSave();
      if (s.id === 'refit' && D.refit === 'refit') {
        window.location.href = SHOP + '/pages/book-a-fitting';
        return;
      }
      if (s.id === 'pay' && D.pay === 'cash') {
        resolveLineItems(true).then(function (resolved) {
          finishOrder(resolved, true);
          redirectToCart(resolved);
        });
        return;
      }
      if (s.id === 'sign') {
        resolveLineItems(false).then(function (resolved) {
          finishOrder(resolved, false);
          i++;
          paint();
        });
        return;
      }
      if (i < order.length - 1) { i++; paint(); }
    }
  
    function goCheckout() {
      var items = [{ handle: FORM_HANDLE[D.spareShade], qty: 1, title: 'Spare Breast Form' }];
      Promise.all(items.map(function (it) {
        return fetchProduct(it.handle).then(function (product) {
          var variant = firstAvailableVariant(product);
          return variant ? { variant_id: variant.id, quantity: 1 } : null;
        });
      })).then(function (resolved) {
        resolved = resolved.filter(Boolean);
        if (resolved.length) redirectToCart(resolved);
        else window.location.href = SHOP + '/products/' + FORM_HANDLE[D.spareShade];
      });
    }
  
    function prev() {
      if (i > 0) { i--; paint(); }
    }
  
    function save() {
      try { localStorage.setItem('myya_reorder', JSON.stringify({ D: D, i: i })); } catch (e) {}
    }
  
    function load() {
      try {
        var r = JSON.parse(localStorage.getItem('myya_reorder'));
        if (r && r.D) {
          Object.assign(D, r.D);
          if (typeof r.i === 'number') i = r.i;
        }
      } catch (e) {}
    }
  
    function flashSave() {
      var n = root.querySelector('#rr-save-note');
      if (!n) return;
      n.style.transition = 'opacity .3s';
      n.style.opacity = 1;
      setTimeout(function () { n.style.opacity = 0; }, 1600);
    }
  
    function submit() {
      resolveLineItems(D.pay === 'cash').then(function (resolved) {
        finishOrder(resolved, D.pay === 'cash');
      });
    }

root.addEventListener('click', function (e) {
var t = e.target.closest('[data-action], [data-set], [data-bra-style], [data-bra-color], [data-jump]');
if (!t || !root.contains(t)) return;

if (t.dataset.action === 'next') next();
      else if (t.dataset.action === 'prev') prev();
      else if (t.dataset.action === 'checkout') goCheckout();
      else if (t.dataset.set) setV(t.dataset.set, t.dataset.value);
      else if (t.dataset.braStyle != null) setBraStyle(parseInt(t.dataset.braStyle, 10), t.dataset.style);
      else if (t.dataset.braColor != null) setBraColor(parseInt(t.dataset.braColor, 10), t.dataset.color);
      else if (t.dataset.jump) jumpTo(t.dataset.jump);
    });
  
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-sync]')) chk();
    });
  
    document.addEventListener('keydown', function (e) {
      if (!root.contains(document.activeElement) && document.activeElement !== document.body) return;
      if (e.key === 'Enter' && !e.shiftKey) {
        var t = e.target;
        if (t && t.tagName === 'TEXTAREA') return;
        e.preventDefault();
        var b = root.querySelector('#rr-go-btn');
        if (b && !b.disabled) next();
        else if (cur().id === 'welcome') next();
      }
    });
  
    load();
    paint();
  })();
  